/**
 * @license Copyright (c) Microsoft Corporation.  All rights reserved.
 */
import { formCaptureFactory } from "./FormCaptureFactory";
import { Logger } from "../../FormLoader/src/Logger";
import { waitForElement } from "./HtmlUtils";
var logger = new Logger();
var factory = formCaptureFactory(logger);
var formCapture = factory();
var ExternalApi = /** @class */ (function () {
    function ExternalApi() {
    }
    ExternalApi.serializeForm = function (form, mappings, location) {
        if (location === void 0) { location = window.location.href; }
        return formCapture.serializeForm(form, mappings, location);
    };
    ExternalApi.submitForm = function (captureConfig, serializedForm) {
        return formCapture.submitForm(captureConfig, serializedForm);
    };
    ExternalApi.waitForElement = waitForElement;
    return ExternalApi;
}());
export { ExternalApi };
